export default {
      id: "bullet-arrow-right-usage",
      viewBox: "0 0 5 8",
      url: "/" + "img/marilyn-ui.svg#bullet-arrow-right",
      toString: function () {
        return this.url;
      }
    }